<template>

  <v-container v-show="isMounted" >
    <v-layout row align-center justify-center>
<img src="http://localhost:8088/app/vue/static/images/login/logo.png" class="logo" alt="">
</v-layout>
    <div class="text-xs-center">
        
      <h2>REGÍSTRATE EN {{ appName }}</h2> 
    </div>
    <v-layout row align-center justify-center>

      <v-btn to="/register/store" outline color="primary" large>Comerciante</v-btn>
      <v-btn to="/register/installer" outline color="primary" large>Instalador</v-btn>
    </v-layout>

  </v-container>

</template>

<script>
  import theme from 'config/theme'
  import app from 'config/app'

  export default {
    data () {
      return {
        appName: app.name,
        isMounted: false,
        path: this.$route.path.toLowerCase(),
        passwordOne: '',
        passwordTwo: '',
        appendIconOne: () => (this.visibilityOne = !this.visibilityOne),
        appendIconTwo: () => (this.visibilityTwo = !this.visibilityTwo),
        visibilityOne: true,
        visibilityTwo: true
      }
    },

    mounted () {
      this.isMounted = true
    },

    methods:
    {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCardStyle: function getCardStyle () {
        return 'theme--' + theme.route[this.path].styles.card
      },

      /**
       * Get custom parameters or use the default parameters.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      register: function register () {
        this.$store.dispatch('api/register', {
          passwordOne: this.passwordOne,
          passwordTwo: this.passwordTwo
        }).then(() => {
          if (this.$store.getters['api/isAuthorizedUser']) {
            return this.$router.push('/dashboard')
          }
          this.$store.dispatch(
            'snackbar/show',
            'Usuario o contraseña incorrectos'
          )
        })
      }
    }
  }
</script>

<style lang="sass">

#register-page
  background: #373c40
  -webkit-transform-style: preserve-3d
  -moz-transform-style: preserve-3d
  transform-style: preserve-3d
  height: 100%

  h2
   color: white
   padding: 20px
   font-size: 2.5em

  > .container
    max-width: 500px
    margin: 0 auto
    position: relative
    top: 50%
    transform: translateY(-50%)

  .logo
    height: 200px
</style>



// WEBPACK FOOTER //
// src/pages/register.vue